export namespace ContainerTranslations {
  export const common = {
    container: 'container',
    containerType: 'containerType',
  } as const;

  export const error = {
    containersUnableToLoadError: 'containersUnableToLoadError',
  } as const;

  export const components = {
    containerDeletedSuccessfullyToastTitle: 'containerDeletedSuccessfullyToastTitle',
    deleteContainerModalTitle: 'deleteContainerModalTitle',
    deleteContainerModalSubtitle: 'deleteContainerModalSubtitle',
    deleteContainer: 'deleteContainer',
  } as const;
}
